module.exports = __webpack_public_path__ + "img/lg_e1.ba040e9b.png";